import { useState } from 'react';
import { QuestionIcon, WarningIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SmartPropertyCitationPopover } from 'smart-property-lib';
import { EventBarrier } from '../utils/EventBarrier';
import { jsx as _jsx } from "react/jsx-runtime";
const getIcon = (status, error) => {
  if (error === 'INVALID_AGENT_RESULT_PII_DETECTED' || status === 'completedNoResult') {
    return /*#__PURE__*/_jsx(IconCircle, {
      backgroundColor: "fill-accent-red-default",
      color: "fill-surface-default",
      icon: QuestionIcon,
      padding: "25",
      size: "100"
    });
  }
  return /*#__PURE__*/_jsx(IconHolder, {
    color: "fill-accent-red-default",
    icon: WarningIcon,
    padding: "0",
    size: "400"
  });
};
export const SmartPropertyRunStatus = ({
  error,
  smartPropertyResultId,
  status
}) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  const handleEventCapture = event => {
    event.stopPropagation();
  };
  const handleOpenChange = event => {
    setOpen(event.target.value);
  };
  return /*#__PURE__*/_jsx(EventBarrier, {
    onEventCapture: handleEventCapture,
    children: /*#__PURE__*/_jsx(SmartPropertyCitationPopover, {
      onOpenChange: handleOpenChange,
      open: open,
      smartPropertyResultId: smartPropertyResultId,
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: handleClick,
        size: "xs",
        use: "transparent",
        children: getIcon(status, error)
      })
    })
  });
};